import React from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";

function SidbarPage() {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = React.useState(false);
  React.useEffect(() => {
    const token = localStorage.getItem("Token");

    if (token) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  }, []);

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <div
        className="area"
        style={{
          marginLeft: isHovered ? "260px" : "60px",
          transition: "margin-left 0.3s",
          width: isHovered ? "calc(100% - 260px)" : "calc(100% - 60px)",
        }}
      >
        <Outlet />
      </div>
      <nav
        className="main-menu"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <ul>
          <li>
            <div className="logo"></div>
          </li>
          <li>
            <Link to="/">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M3 10.5L12 3.5L21 10.5" />

                <rect x="6" y="10.5" width="12" height="10" />
                <path d="M10 20.5V14.5H14V20.5" />
              </svg>

              <span className="nav-text">Home</span>
            </Link>
          </li>
          <li>
            <Link to="/dashboard/legal-analyzer">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="10" cy="10" r="6" />
                <line x1="14" y1="14" x2="21" y2="21" />

                <line x1="10" y1="4" x2="10" y2="2" />
                <line x1="6" y1="7" x2="10" y2="4" />
                <line x1="10" y1="4" x2="14" y2="7" />
                <line x1="6" y1="7" x2="6" y2="12" />
                <line x1="14" y1="7" x2="14" y2="12" />
                <circle cx="6" cy="12" r="1.5" />
                <circle cx="14" cy="12" r="1.5" />
              </svg>
              <span className="nav-text">Contract Assist</span>
            </Link>
          </li>
          <li>
            <Link to="/dashboard/legal-summary">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M6 2h9l5 5v13c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2z" />
                <path d="M14 2v6h6" />

                <path d="M9 12h6" />
                <path d="M9 16h3" />

                <path d="M9 20l2 2 4-4" />
              </svg>
              <span className="nav-text">Contract Summary</span>
            </Link>
          </li>
        </ul>

        <ul className="logout">
          <li>
            <a onClick={logout}>
              <i className="fa fa-power-off fa-2x"></i>
              <span className="nav-text">Logout</span>
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default SidbarPage;
